var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QUOQUEST"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-111 -1678C-111 -1679.1 -110.105 -1680 -109 -1680H7471C7472.1 -1680 7473 -1679.1 7473 -1678V598C7473 599.105 7472.1 600 7471 600H-109C-110.105 600 -111 599.105 -111 598V-1678Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Overlay/Assist/quoquest",
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 126",
    d: "M-32 -155C-32 -168.255 -21.2548 -179 -8 -179H317C330.255 -179 341 -168.255 341 -155V512H-32V-155Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1255"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -11,
    width: 118,
    height: 38,
    rx: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "robot",
    d: "M5.33333 8C5.82222 8 6.24074 7.82593 6.58889 7.47778C6.93704 7.12963 7.11111 6.71111 7.11111 6.22222C7.11111 5.73333 6.93704 5.31482 6.58889 4.96667C6.24074 4.61852 5.82222 4.44444 5.33333 4.44444C4.84444 4.44444 4.42593 4.61852 4.07778 4.96667C3.72963 5.31482 3.55556 5.73333 3.55556 6.22222C3.55556 6.71111 3.72963 7.12963 4.07778 7.47778C4.42593 7.82593 4.84444 8 5.33333 8ZM10.6667 8C11.1556 8 11.5741 7.82593 11.9222 7.47778C12.2704 7.12963 12.4444 6.71111 12.4444 6.22222C12.4444 5.73333 12.2704 5.31482 11.9222 4.96667C11.5741 4.61852 11.1556 4.44444 10.6667 4.44444C10.1778 4.44444 9.75926 4.61852 9.41111 4.96667C9.06296 5.31482 8.88889 5.73333 8.88889 6.22222C8.88889 6.71111 9.06296 7.12963 9.41111 7.47778C9.75926 7.82593 10.1778 8 10.6667 8ZM5.33333 16V12.4444H7.11111V16H5.33333ZM8.88889 16V12.4444H10.6667V16H8.88889ZM1.77778 16C1.28889 16 0.87037 15.8259 0.522222 15.4778C0.174074 15.1296 0 14.7111 0 14.2222V5.33333C0 3.85185 0.518518 2.59259 1.55556 1.55556C2.59259 0.518518 3.85185 0 5.33333 0H10.6667C12.1481 0 13.4074 0.518518 14.4444 1.55556C15.4815 2.59259 16 3.85185 16 5.33333V14.2222C16 14.7111 15.8259 15.1296 15.4778 15.4778C15.1296 15.8259 14.7111 16 14.2222 16H12.4444V12.4444C12.4444 11.9556 12.2704 11.537 11.9222 11.1889C11.5741 10.8407 11.1556 10.6667 10.6667 10.6667H5.33333C4.84444 10.6667 4.42593 10.8407 4.07778 11.1889C3.72963 11.537 3.55556 11.9556 3.55556 12.4444V16H1.77778Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M-109 -1679H7471V-1681H-109V-1679ZM7472 -1678V598H7474V-1678H7472ZM7471 599H-109V601H7471V599ZM-110 598V-1678H-112V598H-110ZM-109 599C-109.552 599 -110 598.552 -110 598H-112C-112 599.657 -110.657 601 -109 601V599ZM7472 598C7472 598.552 7471.55 599 7471 599V601C7472.66 601 7474 599.657 7474 598H7472ZM7471 -1679C7471.55 -1679 7472 -1678.55 7472 -1678H7474C7474 -1679.66 7472.66 -1681 7471 -1681V-1679ZM-109 -1681C-110.657 -1681 -112 -1679.66 -112 -1678H-110C-110 -1678.55 -109.552 -1679 -109 -1679V-1681Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white",
    transform: "translate(-32 -300)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotFull);
export default __webpack_public_path__ + "static/media/robot-full.20b72724e664f410290bd9931a06ed91.svg";
export { ForwardRef as ReactComponent };